module.exports = __webpack_public_path__ + "static/media/pexels-4.7572d3f6.jpg";